var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { useRef, useState } from 'react';
import { InputStyle } from './style';
import './index.scss';
var STYLETYPE;
(function (STYLETYPE) {
    STYLETYPE["ROUNDED_INPUT"] = "rounded";
    STYLETYPE["BORDER_BOTTOM_INPUT"] = "line";
})(STYLETYPE || (STYLETYPE = {}));
export var TextField = function (props) {
    var inputRef = useRef(null);
    var _a = useState(false), focus = _a[0], changeFocus = _a[1];
    var handleBlur = function (event) {
        if (props.handleBlur) {
            props.handleBlur(event.currentTarget.value);
        }
        changeFocus(false);
    };
    return (React.createElement("div", { className: "text-field-container" },
        React.createElement("div", { className: "label-wrapper" },
            props.label ?
                React.createElement("div", { className: "label" }, props.label) : null,
            !props.isRequired && React.createElement("span", { className: "form-optional" }, "Optional"),
            props.tooltipLabel &&
                React.createElement("div", { className: "form-tooltip" },
                    React.createElement("span", { className: "form-tooltiptext form-tooltip-right" }, props.tooltipLabel))),
        React.createElement("div", { className: "text-field flex-center-row ".concat(focus ? " active" : "") },
            React.createElement("input", { id: props.fieldName, className: "".concat(props.index === 0 || props.index ? 's-form-input' : '', " ").concat(props.type === 'date' ? 's-form-date' : '', " ").concat(props.validated === 'error' ? 's-form-invalid' : '', " ").concat(props.validated === 'success' ? 's-form-success' : '', " ").concat(props.validated === 'warning' ? 's-form-warning' : ''), style: STYLETYPE.BORDER_BOTTOM_INPUT === props.styleType ?
                    focus ? __assign(__assign({}, InputStyle.lineStyle['default']), InputStyle.lineStyle['focus']) : InputStyle.lineStyle['default'] :
                    STYLETYPE.ROUNDED_INPUT === props.styleType ? focus ? __assign(__assign({}, InputStyle.roundedStyle['default']), InputStyle.roundedStyle['focus']) : InputStyle.roundedStyle['default'] : {}, ref: inputRef, type: props.type, placeholder: props.placeholder, value: props.value !== null ? props.value : '', min: props.min, max: props.max, maxLength: props.max && typeof props.max === 'number' ? props.max : undefined, minLength: props.min && typeof props.min === 'number' ? props.min : undefined, disabled: props.disabled, readOnly: props.isReadOnly, required: props.isRequired, "aria-invalid": props.validated === 'error', onChange: function (event) { return props.onChange(props.fieldName, event.currentTarget.value, event); }, onFocus: function () { return changeFocus(true); }, onBlur: handleBlur, onKeyPress: function (event) { if (props.type === 'number' && props.max && (event.currentTarget.value.length > Number(props.max) - 1)) {
                    event.preventDefault();
                    return false;
                } } })),
        props.errorMsg ?
            React.createElement("div", { className: "error-message flex-center-row" }, props.errorMsg) : null));
};
TextField.defaultProps = {
    isRequired: true,
};
export default TextField;
//# sourceMappingURL=index.js.map